import gql from 'graphql-tag';
import { USER_FIELDS } from '../../data/graphql';

export const LOGIN = gql`
    query Login($email: String!, $password: String!){
        login(email:$email, password:$password) {
            token,
            user {
                ${USER_FIELDS}
            }
        }
    }
`;

export const GET_USER = gql`
    query GetUser($id: MongoID!){
        user: userById(_id:$id) {
            ${USER_FIELDS}
        }
    }
`;

export const OIDC_START_LOGIN = gql`
  mutation OidcStartLogin {
    oidcStartLogin {
      authUrl
    }
  }
`;

export const OIDC_LOGIN = gql`
  mutation OidcLogin($code: String!, $state: String!) {
    oidcLogin(code: $code, state: $state) {
      token
      user {
        ${USER_FIELDS}
      }
      requiresOnboarding
      requiresPasswordConfirm
      linkToken
      onboardingToken
      profile {
        email
        firstName
        lastName
      }
    }
  }
`;

export const OIDC_CONFIRM_LINK = gql`
  mutation OidcConfirmLink($linkToken: String!, $password: String!) {
    oidcConfirmLink(linkToken: $linkToken, password: $password) {
      token
      user {
        ${USER_FIELDS}
      }
    }
  }
`;

export const OIDC_CANCEL_LINK = gql`
  mutation OidcCancelLink($linkToken: String!) {
    oidcCancelLink(linkToken: $linkToken) {
      success
    }
  }
`;
